import styled from 'styled-components'

import { Section as GSSection, Infos as GSInfos } from 'components/general-styles/General'
import { theme } from 'styles/theme'

const { media, space } = theme

export const Section = styled(GSSection)`
  button {
    justify-content: center;
    width: 100%;
  }

  @media (${media.tablet}) {
    padding-top: ${space['spacing-xl']};
    padding-bottom: ${space['spacing-xl']};

    button {
      justify-content: space-between;
      width: 19rem;
    }
  }

  @media (${media.desktop}) {
    padding-top: 7.5rem;
  }
`

export const DeskImg = styled.span`
  position: relative;
  display: none;
  
  @media (${media.tablet}) {
    display: block;
  }
`

export const MobImg = styled.span`
  position: relative;

  @media (${media.tablet}) {
    display: none;
  }
`

export const Infos = styled(GSInfos)`
  margin-top: ${space['spacing-md']};

  p:last-child {
    margin-bottom: 0;
  }

  @media (${media.tablet}) {
    p:last-of-type {
      margin-bottom: ${space['spacing-xl']};
    }
  }
`
